<template>
    <v-row no-gutters class="mx-1">
        <v-row justify="center" align="center" v-if="loading">
            <div class="text-center">
                <div>
                    <v-progress-circular
                        class="my-4"
                        :size="50"
                        width="5"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </div>
                <p class="display-1">{{ $t('Loading') }}...</p>
            </div>
        </v-row>
        <v-col
            v-if="!loading"
            v-for="(provider, index) in providers"
            :key="provider.uuid"
            cols="12"
            class="mb-2"
        >
            <v-card class="pa-2" flat>
                <v-row class="align-center" justify="space-between">
                    <v-col cols="8">
                        <h4 class="font-weight-regular ml-2">
                            {{ provider.ProviderName }}
                        </h4>
                    </v-col>
                    <v-col class="d-flex justify-end" cols="4">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    v-on="on"
                                    class="ml-2"
                                    color="primary"
                                    icon
                                    :loading="checkingCredentials[index]"
                                    @click="
                                        checkCredentialsOfProvider(
                                            provider,
                                            index
                                        )
                                    "
                                >
                                    <v-icon large
                                        >mdi-folder-search-outline</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('Test') }}</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    v-on="on"
                                    class="ml-2"
                                    icon
                                    color="red"
                                    @click="
                                        deleteParameters(
                                            provider.DocumentIntelligenceProviderID
                                        )
                                    "
                                >
                                    <v-icon large>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('Delete') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-card-text>
                    <v-row>
                        <v-col
                            v-for="item in provider.Parameters"
                            :key="item.key"
                            cols="12"
                        >
                            <v-text-field
                                v-model="item.Value"
                                hide-details
                                :label="item.Name"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import DocumentIntelligenceProvidersService from '@/services/DocumentIntelligenceProvidersService.js';
import Utils from '@/ecm/common/Utils';
export default {
    name: 'ProvidersList',
    components: {},
    props: {
        providers: Array,
    },
    data() {
        return {
            loading: false,
            checkingCredentials: [],
        };
    },
    methods: {
        async checkCredentialsOfProvider(provider, index) {
            this.$set(this.checkingCredentials, index, true);
            const checkCredentialsRequest = {
                DocumentIntelligenceProviderID:
                    provider.DocumentIntelligenceProviderID,
                Parameters: provider.Parameters,
            };

            try {
                const result =
                    await DocumentIntelligenceProvidersService.checkCredentialsOfProvider(
                        checkCredentialsRequest
                    );
                if (result) {
                    Utils.toast.success(this.$t('CorrectCredentials'));
                } else {
                    Utils.toast.error(
                        this.$t('InvalidCredentialsOfProvider').replaceAll(
                            '{0}',
                            provider.ProviderName
                        )
                    );
                }
            } finally {
                this.$set(this.checkingCredentials, index, false);
            }
        },
        deleteParameters(providerId) {
            const idsToDelete = this.providers
                .filter(
                    (provider) =>
                        provider.DocumentIntelligenceProviderID === providerId
                )
                .flatMap((provider) =>
                    provider.Parameters.map((parameter) => parameter.Id)
                );

            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    this.loading = true;
                    DocumentIntelligenceProvidersService.deleteSettingsValues(
                        idsToDelete
                    )
                        .then(() => {
                            this.providers
                                .filter(
                                    (provider) =>
                                        provider.DocumentIntelligenceProviderID ===
                                        providerId
                                )
                                .forEach((provider) => {
                                    provider.Parameters.forEach((parameter) => {
                                        parameter.Value = '';
                                        parameter.Id = 0;
                                    });
                                });
                            this.loading = false;
                        })
                        .catch(() => {});
                }
            });
        },
    },
};
</script>